function heuristic(a, b) {
  const deltaX = Math.abs(a.x - b.x);
  const deltaY = Math.abs(a.y - b.y);
  const diagonalSteps = Math.min(deltaX, deltaY);
  const straightSteps = Math.abs(deltaX - deltaY);

  return diagonalSteps * Math.SQRT2 + straightSteps;
}

function movementCost(a, b) {
  return a.x !== b.x && a.y !== b.y ? Math.SQRT2 : 1;
}

export { heuristic, movementCost };
